import { ExportFn } from '@/components/ConfigurableColumns';

export type CsvExporterTransformer = (doc: any) => string;

export type CsvExporterTuple = [string, CsvExporterTransformer];

export const genericCSVExporter =
  (entityName: string, fields: [string, ExportFn][]) =>
  async (documents: any[], _: any) => {
    const titles = fields.map(([title]) => title).join(',');

    const csvData = documents
      .map(doc =>
        fields
          .map(([, transformer]) => transformer(doc))
          .map(field => {
            const isNullOrUndefined =
              field === null || field === undefined;

            const validFieldContent = !isNullOrUndefined ? field : '';

            return String(validFieldContent).replace(/,/g, '');
          })
          .join(','),
      )
      .join('\n');

    const fileData = [titles, csvData].join('\n');

    downloadFile(
      fileData,
      `export-${entityName}-${new Date().toISOString()}.csv`,
    );
  };

export const extractCreationDate = (objectIdLike?: string | null) => {
  if (objectIdLike?.length !== 24) {
    return null;
  }

  return new Date(parseInt(objectIdLike.slice(0, 8), 16) * 1000);
};

// Shamelessly copied from here, as it's not in the exported API:
// https://github.com/marmelab/react-admin/blob/master/packages/ra-core/src/export/downloadCSV.ts
export const downloadFile = (
  content: string,
  filename: string,
): void => {
  const fakeLink = document.createElement('a');
  fakeLink.style.display = 'none';
  document.body.appendChild(fakeLink);
  const blob = new Blob([content], {
    type: 'text/csv;charset=utf-8',
  });
  // @ts-expect-error - window.navigator.msSaveOrOpenBlob is not defined in the browser
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // Manage IE11+ & Edge
    // @ts-expect-error - window.navigator.msSaveOrOpenBlob is not defined in the browser
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    fakeLink.setAttribute('href', URL.createObjectURL(blob));
    fakeLink.setAttribute('download', filename);
    fakeLink.click();
  }
};
